export function getLozengeClass(type) {
  try {
    if (!type) {
      return "grey lighten-2";
    }

    let output = {
      compromiso: "blue",
      duda: "orange",
      acuerdo: "green",
      desacuerdo: "red",
      disagreement: "red",
      votacion: "purple",
    };

    return output[type] + " lighten-2";
  } catch (e) {
    console.error("Error in getLozengeClass:", e);
  }
}

export function formatDateTimeToDate(datetime) {
  const date = new Date(datetime);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  console.log("formattedDate", day, month, year);
  return `${day}/${month}/${year}`;
}

export function formatDateTimeToTime(datetime) {
  if (!datetime) return "";
  const date = new Date(datetime);
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  return `${hours}:${minutes}`;
}
